import axios from '@/utils/request'

export default {
	// 2021-10-09
	findByTenantId(token = null) {
		return axios.get('/configs/find-by-tenant-id')
	},
	//   // 2020-07-08
	//   update(id, params) {
	//     return axios.put('/configs/' + id, params)
	//   }

}

